import React, { FunctionComponent, useContext } from "react";
import { Button } from "@cmsgov/ds-medicare-gov";
import { useTranslate } from "../../helpers";
import { AppContext } from "../../app/store";
import {
  AnalyticsActionType,
  AnalyticsButtonStyle,
  AnalyticsButtonType,
} from "../../app/contexts/Analytics/types";

interface BackNextButtonsProps {
  nextPage: () => void;
  previousPage: () => void;
  hideBackButton?: boolean;
  nextText?: string;
  disableNext?: boolean;
  inReview: boolean;
}

const BackNextButtons: FunctionComponent<BackNextButtonsProps> = ({
  nextPage,
  previousPage,
  hideBackButton,
  inReview,
  nextText,
  disableNext,
}) => {
  const { dispatch } = useContext(AppContext);
  const t = useTranslate();

  return (
    <div className="EnrollmentFormPage__buttons">
      {!hideBackButton && !inReview && (
        <Button
          className="EnrollmentFormPage__backButton"
          onClick={() => {
            dispatch({
              type: AnalyticsActionType.SEND_BUTTON_ENGAGEMENT_EVENT,
              settings: {
                button: {
                  buttonStyle: AnalyticsButtonStyle.DEFAULT,
                  buttonType: AnalyticsButtonType.BUTTON,
                  text: t("back"),
                },
              },
            });
            previousPage();
          }}
        >
          {t("back")}
        </Button>
      )}

      <Button
        variation="solid"
        className="EnrollmentFormPage__nextButton"
        disabled={disableNext}
        onClick={() => {
          dispatch({
            type: AnalyticsActionType.SEND_BUTTON_ENGAGEMENT_EVENT,
            settings: {
              button: {
                buttonStyle: AnalyticsButtonStyle.PRIMARY,
                buttonType: AnalyticsButtonType.BUTTON,
                text: nextText || (inReview ? t("save") : t("next")),
              },
            },
          });
          nextPage();
        }}
      >
        {nextText || (inReview ? t("save") : t("next"))}
      </Button>
    </div>
  );
};

export default BackNextButtons;
